import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";

export default (reason: ShiftDeclinedReason) => {
    let text = "N/A"
    switch (reason) {
        case ShiftDeclinedReason.BOOKING_DECLINED_REASON_TOO_SHORT_NOTICE:
            text = "Short notice";
            break;
        case ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNAVAILABLE:
            text = "Unavailable";
            break;
        case ShiftDeclinedReason.BOOKING_DECLINED_REASON_WORKING_ELSEWHERE:
            text = "Working elsewhere";
            break;
        case ShiftDeclinedReason.BOOKING_DECLINED_REASON_TRANSPORT:
            text = "Transport issue";
            break;
        case ShiftDeclinedReason.BOOKING_DECLINED_REASON_PAY_RATE:
            text = "Pay rate";
            break;
        case ShiftDeclinedReason.BOOKING_DECLINED_REASON_POSITION:
            text = "Position";
            break;
        default:
            text = "N/A";
            break;
    }
    return text;
} 